import React, { useMemo } from 'react';
import { Tabs, Tab } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMessages } from 'modules/intl';
import { useMeContext } from 'modules/me';
import { SettingsType } from './constant';

const sidePanelMessages = ['settings.startEndTime', 'settings.smartSuggestion'];

const useTabsStyles = makeStyles(() => ({
  root: {
    width: '100%'
  }
}));

type SettingsTabsProps = {
  showSettingPageType: React.Dispatch<
    React.SetStateAction<SettingsType | undefined>
  >;
  settingPagetype: SettingsType | undefined;
};

export const SettingsTabs: React.FC<SettingsTabsProps> = ({
  showSettingPageType,
  settingPagetype
}: SettingsTabsProps) => {
  const tabsClasses = useTabsStyles();
  const messages = useMessages(sidePanelMessages);
  const me = useMeContext();
  const sidePanelItemList = useMemo(
    () => [
      me?.permissions.hasStartEndEditAccess
        ? {
            testId: 'setting-type-start-end-time',
            message: messages['settings.startEndTime'],
            value: SettingsType.START_END_TIME,
            key: 'startEndTime'
          }
        : {},
      me?.permissions.hasSmartSuggestionEditAccess
        ? {
            testId: 'setting-type-smart-suggestion',
            message: messages['settings.smartSuggestion'],
            value: SettingsType.SMART_SUGGESTION,
            key: 'smartSuggestion'
          }
        : {}
    ],
    [
      me?.permissions.hasSmartSuggestionEditAccess,
      me?.permissions.hasStartEndEditAccess,
      messages
    ]
  );

  const handleChange = useMemo(
    () => (_event: React.SyntheticEvent, newValue: SettingsType) => {
      showSettingPageType(newValue);
    },
    [showSettingPageType]
  );

  return (
    <Tabs
      classes={tabsClasses}
      value={settingPagetype}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      data-testid="settings-tabs"
    >
      {sidePanelItemList.map((item) => (
        <Tab
          key={item.key}
          value={item.value}
          label={item.message}
          data-testid={item.testId}
        />
      ))}
    </Tabs>
  );
};

export default SettingsTabs;
